import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  border-radius: 8px;
  gap: 8px;
`;

export const WrapperLink = styled.button`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: background-color 0.5 ease-in-out;
  border: none;

  &:focus {
    outline: 0;
  }

  ${({ active, tabsLength, theme }) => `
    width: ${100 / tabsLength}%;
    background-color: ${
      active ? theme.colors.primary500 : theme.colors.semantic.surface.card
    };
    color: ${
      active ? theme.colors.highWhite : theme.colors.semantic.text.primary
    };
  `}
`;
